/* eslint-disable max-len */
/**
 * Awvent - Documents API
 * Awvent Documents Apis
 *
 * OpenAPI spec version: v1
 * Contact: info@prestine.in
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient,
    HttpHeaders,
    HttpParams,
    HttpResponse,
    HttpEvent,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

import { BooleanWebApiResponse } from '../../../common/models/booleanWebApiResponse';
import { DocumentDtoListWebApiPagedResponse } from '../model/documentDtoListWebApiPagedResponse';
import { DocumentDtoWebApiResponse } from '../model/documentDtoWebApiResponse';
import { DocumentUpdateCommand } from '../model/documentUpdateCommand';
import { AudienceDto } from '../../product/model/audienceDto';
import { ContentKind } from '../model/contentKind';
import { IndexStatus } from '../model/indexStatus';
import { DocumentDownloadDto } from '../model/documentDownloadDto';

import { Configuration } from '../../../../configuration';
import { CustomHttpUrlEncodingCodec } from '../../../../encoder';
import { BASE_PATH, COLLECTION_FORMATS } from '../../../../variables';

/** SPEC-web-planner-033 AC-8: one entry of GET Document/Product/{productId}/Brochures (BrochureDto). */
export interface BrochureDto {
    id?: string;
    name?: string;
    sizeBytes?: number;
}

@Injectable()
export class DocumentService {
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    protected basePath = environment.api.documents;

    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string,
        @Optional() configuration: Configuration
    ) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     *
     *
     * @param xTenantId
     * @param folderPath
     * @param userId
     * @param name
     * @param type
     * @param orderBy
     * @param isOrderByDescending
     * @param searchText
     * @param pageNumber
     * @param pageSize
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public documentGet(xTenantId: string, folderPath?: string, userId?: string, name?: string, type?: string, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<DocumentDtoListWebApiPagedResponse>;
    public documentGet(xTenantId: string, folderPath?: string, userId?: string, name?: string, type?: string, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DocumentDtoListWebApiPagedResponse>>;
    public documentGet(xTenantId: string, folderPath?: string, userId?: string, name?: string, type?: string, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DocumentDtoListWebApiPagedResponse>>;
    public documentGet(xTenantId: string, folderPath?: string, userId?: string, name?: string, type?: string, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling documentGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (folderPath !== undefined && folderPath !== null) {
            queryParameters = queryParameters.set('FolderPath', folderPath);
        }
        if (userId !== undefined && userId !== null) {
            queryParameters = queryParameters.set('UserId', userId);
        }
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('Name', name);
        }
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('Type', type);
        }
        if (orderBy) {
            orderBy.forEach((element) => {
                queryParameters = queryParameters.append('OrderBy', element);
            });
        }
        if (isOrderByDescending !== undefined && isOrderByDescending !== null) {
            queryParameters = queryParameters.set('IsOrderByDescending', isOrderByDescending);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', searchText);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', pageSize);
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DocumentDtoListWebApiPagedResponse>('get',`${this.basePath}/Document`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public documentIdDelete(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<BooleanWebApiResponse>;
    public documentIdDelete(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BooleanWebApiResponse>>;
    public documentIdDelete(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BooleanWebApiResponse>>;
    public documentIdDelete(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling documentIdDelete.');
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling documentIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BooleanWebApiResponse>('delete',`${this.basePath}/Document/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public documentIdGet(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<DocumentDtoWebApiResponse>;
    public documentIdGet(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DocumentDtoWebApiResponse>>;
    public documentIdGet(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DocumentDtoWebApiResponse>>;
    public documentIdGet(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling documentIdGet.');
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling documentIdGet.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DocumentDtoWebApiResponse>('get',`${this.basePath}/Document/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param id
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public documentIdPut(xTenantId: string, id: string, body?: DocumentUpdateCommand, observe?: 'body', reportProgress?: boolean): Observable<DocumentDtoWebApiResponse>;
    public documentIdPut(xTenantId: string, id: string, body?: DocumentUpdateCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DocumentDtoWebApiResponse>>;
    public documentIdPut(xTenantId: string, id: string, body?: DocumentUpdateCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DocumentDtoWebApiResponse>>;
    public documentIdPut(xTenantId: string, id: string, body?: DocumentUpdateCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling documentIdPut.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling documentIdPut.');
        }


        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<DocumentDtoWebApiResponse>('put',`${this.basePath}/Document/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param file
     * @param name
     * @param folderPath
     * @param description
     * @param tags
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public documentPostForm(xTenantId: string, file?: Blob, name?: string, folderPath?: string, description?: string, tags?: { [key: string]: string }, observe?: 'body', reportProgress?: boolean): Observable<DocumentDtoWebApiResponse>;
    public documentPostForm(xTenantId: string, file?: Blob, name?: string, folderPath?: string, description?: string, tags?: { [key: string]: string }, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DocumentDtoWebApiResponse>>;
    public documentPostForm(xTenantId: string, file?: Blob, name?: string, folderPath?: string, description?: string, tags?: { [key: string]: string }, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DocumentDtoWebApiResponse>>;
    public documentPostForm(xTenantId: string, file?: Blob, name?: string, folderPath?: string, description?: string, tags?: { [key: string]: string }, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling documentPost.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void };
        let useForm = false;
        const convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('File', file) as any || formParams;
        }
        if (name !== undefined) {
            formParams = formParams.append('Name', name) as any || formParams;
        }
        if (folderPath !== undefined) {
            formParams = formParams.append('FolderPath', folderPath) as any || formParams;
        }
        if (description !== undefined) {
            formParams = formParams.append('Description', description) as any || formParams;
        }
        if (tags !== undefined) {
            formParams = formParams.append('Tags', tags) as any || formParams;
        }

        return this.httpClient.request<DocumentDtoWebApiResponse>('post',`${this.basePath}/Document`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

    // ──────────────────────────────────────────────────────────────────────
    // GAP-BACKEND-ADMIN-003 / 004 / 006 — extensions for product-manage.
    // ──────────────────────────────────────────────────────────────────────

    private authHeaders(xTenantId: string): HttpHeaders {
        let headers = this.defaultHeaders.set('x-tenant-id', String(xTenantId));
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        const accept = this.configuration.selectHeaderAccept(['application/json', 'text/json', 'text/plain']);
        if (accept !== undefined) {
            headers = headers.set('Accept', accept);
        }
        return headers;
    }

    // GET /api/v1/Document with first-class filters (GAP-BACKEND-ADMIN-003).
    public documentListExtended(
        xTenantId: string,
        opts: {
            productId?: string;
            workspaceWide?: boolean;
            indexStatus?: IndexStatus;
            folderPath?: string;
            name?: string;
            type?: string;
            orderBy?: Array<string>;
            isOrderByDescending?: boolean;
            searchText?: string;
            pageNumber?: number;
            pageSize?: number;
        } = {}
    ): Observable<DocumentDtoListWebApiPagedResponse> {
        let qp = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (opts.productId) { qp = qp.set('ProductId', opts.productId); }
        if (opts.workspaceWide !== undefined) { qp = qp.set('WorkspaceWide', String(opts.workspaceWide)); }
        if (opts.indexStatus !== undefined) { qp = qp.set('IndexStatus', String(opts.indexStatus)); }
        if (opts.folderPath) { qp = qp.set('FolderPath', opts.folderPath); }
        if (opts.name) { qp = qp.set('Name', opts.name); }
        if (opts.type) { qp = qp.set('Type', opts.type); }
        if (opts.orderBy) { opts.orderBy.forEach((el) => qp = qp.append('OrderBy', el)); }
        if (opts.isOrderByDescending !== undefined) { qp = qp.set('IsOrderByDescending', String(opts.isOrderByDescending)); }
        if (opts.searchText) { qp = qp.set('SearchText', opts.searchText); }
        if (opts.pageNumber !== undefined) { qp = qp.set('PageNumber', String(opts.pageNumber)); }
        if (opts.pageSize !== undefined) { qp = qp.set('PageSize', String(opts.pageSize)); }

        return this.httpClient.request<DocumentDtoListWebApiPagedResponse>(
            'get',
            `${this.basePath}/Document`,
            { params: qp, withCredentials: this.configuration.withCredentials, headers: this.authHeaders(xTenantId) }
        );
    }

    // POST /api/v1/Document multipart upload with first-class productId + audience.
    public documentUploadExtended(
        xTenantId: string,
        body: {
            file: Blob;
            name: string;
            folderPath: string;
            description?: string;
            productId?: string | null;
            contentKind?: ContentKind;
            audience?: AudienceDto;
            tags?: { [key: string]: string };
            /** SPEC-web-planner-004 AC-P5-03 — blob metadata Brochure=true. */
            isBrochure?: boolean;
        }
    ): Observable<DocumentDtoWebApiResponse> {
        const form = new FormData();
        form.append('File', body.file);
        form.append('Name', body.name);
        form.append('FolderPath', body.folderPath);
        if (body.description) { form.append('Description', body.description); }
        if (body.productId) { form.append('ProductId', body.productId); }
        if (body.contentKind !== undefined) { form.append('ContentKind', String(body.contentKind)); }
        if (body.audience) { form.append('Audience', JSON.stringify(body.audience)); }
        if (body.isBrochure) { form.append('IsBrochure', 'true'); }
        if (body.tags) {
            Object.keys(body.tags).forEach((k) => form.append(`Tags[${k}]`, body.tags![k]));
        }
        return this.httpClient.request<DocumentDtoWebApiResponse>(
            'post',
            `${this.basePath}/Document`,
            { body: form, withCredentials: this.configuration.withCredentials, headers: this.authHeaders(xTenantId) }
        );
    }

    // PUT /api/v1/Document/{id}/Replace — swap blob behind same id (GAP-003).
    public documentReplace(
        id: string,
        xTenantId: string,
        file: Blob
    ): Observable<DocumentDtoWebApiResponse> {
        const form = new FormData();
        form.append('file', file);
        return this.httpClient.request<DocumentDtoWebApiResponse>(
            'put',
            `${this.basePath}/Document/${encodeURIComponent(id)}/Replace`,
            { body: form, withCredentials: this.configuration.withCredentials, headers: this.authHeaders(xTenantId) }
        );
    }

    // PATCH /api/v1/Document/{id}/Audience — Share modal (GAP-004).
    public documentSetAudience(
        id: string,
        xTenantId: string,
        audience: AudienceDto
    ): Observable<DocumentDtoWebApiResponse> {
        const headers = this.authHeaders(xTenantId).set('Content-Type', 'application/json');
        return this.httpClient.request<DocumentDtoWebApiResponse>(
            'patch',
            `${this.basePath}/Document/${encodeURIComponent(id)}/Audience`,
            { body: audience, withCredentials: this.configuration.withCredentials, headers }
        );
    }

    // POST /api/v1/Document/{id}/RetryIndex (GAP-006).
    public documentRetryIndex(
        id: string,
        xTenantId: string
    ): Observable<DocumentDtoWebApiResponse> {
        return this.httpClient.request<DocumentDtoWebApiResponse>(
            'post',
            `${this.basePath}/Document/${encodeURIComponent(id)}/RetryIndex`,
            { withCredentials: this.configuration.withCredentials, headers: this.authHeaders(xTenantId) }
        );
    }

    // POST /api/v1/Document/GenerateDownloadUri — preview / replace flows.
    public documentGenerateDownloadUri(
        xTenantId: string,
        body: { id: string }
    ): Observable<{ isSuccess?: boolean; result?: DocumentDownloadDto; message?: string }> {
        const headers = this.authHeaders(xTenantId).set('Content-Type', 'application/json');
        return this.httpClient.request<{ isSuccess?: boolean; result?: DocumentDownloadDto; message?: string }>(
            'post',
            `${this.basePath}/Document/GenerateDownloadUri`,
            { body, withCredentials: this.configuration.withCredentials, headers }
        );
    }

    // GET /Document/Product/{productId}/Brochures - SPEC-web-planner-033 AC-8. The controller route is
    // [controller] (no api/v1), the same base as every call above; the product's documents marked as brochures.
    public documentBrochures(
        xTenantId: string,
        productId: string
    ): Observable<{ isSuccess?: boolean; result?: BrochureDto[]; message?: string }> {
        return this.httpClient.request<{ isSuccess?: boolean; result?: BrochureDto[]; message?: string }>(
            'get',
            `${this.basePath}/Document/Product/${encodeURIComponent(productId)}/Brochures`,
            { withCredentials: this.configuration.withCredentials, headers: this.authHeaders(xTenantId) }
        );
    }
}
